import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useUserMapMutation({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext: Api.IImpersonationContext;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IIntegrationUserMapping[]) => void;
}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			type,
			userMap,
		}: {
			type: Api.ConfigurableIntegrationType;
			userMap: Api.IIntegrationUserMapping[];
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IIntegrationUserMapping[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `account/integrations/${type}/userMap`,
				}),
				'PUT',
				userMap
			);
		},
		onError,
		onSuccess,
	});
}
